import React from 'react';
import { Card,Row } from 'react-bootstrap';


class ContentBlock extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Card className='content-block content-block-full'>
                <Card.Body>
                    <Row>
                        {this.props.children}
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default ContentBlock;